import cn from "classnames";
import CopyCoordinates from "components/shared/copyCoordinates";
import DropdownBtn from "components/shared/dropdown";
import { itemChangeTitle } from "helpers/bid";
import { formatDateTimezone } from "helpers/bidpoint";
import { dateTimeToView } from "helpers/date";
import { itemChangePointStatuses, itemChangePointStatusesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { enumLabel } from "helpers/system";
import React from "react";
import ManualDatesForm from "../../bidItemChanges/manualDates";

const PointItemChange = (props) => {
    const {
        mapObject,
        mergeMapViewport,
        nextPoint,
        autoEnteredAt,
        autoLeftAt,
        manualEndAt,
        manualStartAt,
        planEnterDateOffset,
        planLeaveDateOffset,
        shiftCar,
        shiftDriver,
        shiftSecondaryDriver,
        shiftTrailer,
        status,
        visits,
        id,
        bidId,
        creatorDisplayName,
        parallelBidId,
    } = props;

    const { city, village, county, state } = mapObject;

    const completedRoute = () => {
        if (!(autoEnteredAt || manualStartAt) || !nextPoint) {
            return null;
        }
        if ((autoEnteredAt || manualStartAt) && !(autoLeftAt || manualEndAt)) {
            return null;
        }

        const height =
            nextPoint.enteredAt || nextPoint.autoEnteredAt || nextPoint.enteredAtByLogist || nextPoint.manualStartAt
                ? 100
                : 50;
        return (
            <>
                <div className="b-timeline-point__line--green" style={{ height: `${height}%` }} />
                {!(
                    nextPoint.enteredAt ||
                    nextPoint.autoEnteredAt ||
                    nextPoint.enteredAtByLogist ||
                    nextPoint.manualStartAt
                ) && <div className="b-timeline-point__line--car" />}
            </>
        );
    };

    const circleCnames = cn("b-timeline-point__circle", {
        "b-timeline-point__circle--green": autoEnteredAt || manualStartAt,
    });

    const utcTimezone = formatDateTimezone({ planEnterDateOffset: autoEnteredAt });

    const editBtn = () => {
        if (props.roles.isTruckingOrganizationExtendedViewer) {
            return null;
        }
        const btnProps = {
            withoutChevron: true,
            text: <i className="icon-uEA10-pen" />,
            cname: "b-timeline-point__settings",
            align: "end",
            wrapCname: "b-timeline-point__settings--wrap",
            items: [
                ...(visits?.length
                    ? [
                          {
                              text: "Выбрать период нахождения",
                              action: () =>
                                  props.modal({
                                      name: "bidItemChangeVisit",
                                      title: "Выберите период посещения точки",
                                      visits,
                                      id,
                                      bidId,
                                      windowMod: "print",
                                      callback: (success) => success && props.getItem(),
                                  }),
                          },
                      ]
                    : []),
                {
                    text: "Корректировать фактические даты",
                    action: () =>
                        props.modal({
                            name: "default",
                            title: "Корректировать фактические даты",
                            windowMod: "sm",
                            CustomBody: ManualDatesForm,
                            bodyData: {
                                setTitle: () => undefined,
                                getItem: props.getItem,
                                item: { id, bidId, manualStartAt, manualEndAt },
                            },
                            callback: (success) => success && props.getItem(),
                        }),
                },
            ],
        };
        return <DropdownBtn {...btnProps} />;
    };

    return (
        <div className="b-timeline-point">
            <div className="b-timeline-point__figure">
                <div className={circleCnames}>
                    <div className="b-timeline-point__circle--item-changes" />
                </div>
                <div className="b-timeline-point__line">{completedRoute()}</div>
            </div>
            <div className="b-timeline-point__data">
                <div className="b-timeline-point__city">
                    <div className="pb-1 b-timeline-point__city--info">
                        <div>
                            <span
                                className="b-timeline-point__city--name"
                                onClick={() =>
                                    mergeMapViewport({
                                        center: [...mapObject.location.coordinates].reverse(),
                                        zoom: 12,
                                    })
                                }
                            >
                                {city || village || county || state}
                            </span>
                            <small className="b-timeline-point__city--timezone">&nbsp;{utcTimezone}</small>
                        </div>
                        <div className="b-timeline-point__city--type-wrap c-dropd d-inline-flex flex-wrap justify-content-end">
                            <small
                                className={cn("b-timeline-point__city--type badge align-self-baseline", {
                                    "badge-success": status === itemChangePointStatusesEnum.Completed,
                                    "badge-secondary": status !== itemChangePointStatusesEnum.Completed,
                                })}
                            >
                                {enumLabel(itemChangePointStatuses, status)}
                            </small>
                            {editBtn()}
                        </div>
                    </div>
                    <div className="b-timeline-point__city--full">
                        <CopyCoordinates coordinates={[...mapObject.location.coordinates].reverse().join(", ")} />
                        {mapObject.address}
                    </div>
                </div>
                {creatorDisplayName && (
                    <div className="b-timeline-point__text">
                        <div>Автор: {creatorDisplayName}</div>
                    </div>
                )}
                {parallelBidId && (
                    <div className="b-timeline-point__text">
                        <div>
                            Заявка параллельной перецепки:{" "}
                            <a href={paths.bidShow("bid", parallelBidId)} target="_blank" rel="noopener noreferrer">
                                {parallelBidId}
                            </a>
                        </div>
                    </div>
                )}
                <div className="b-timeline-point__text pb-2">
                    {itemChangeTitle(shiftCar, shiftDriver, shiftSecondaryDriver, shiftTrailer)}
                </div>
                <div className="b-timeline-point__info">
                    <div className="b-timeline-point__table">
                        <div className="b-timeline-point__date--header" />
                        <div className="b-timeline-point__date--header">Въезд</div>
                        <div className="b-timeline-point__date--header">Выезд</div>

                        <div className="b-timeline-point__date--name">Плановый</div>
                        <div className="b-timeline-point__date--value">{dateTimeToView(planEnterDateOffset)}</div>
                        <div className="b-timeline-point__date--value">{dateTimeToView(planLeaveDateOffset)}</div>

                        <div className="b-timeline-point__date--name">Фактический</div>
                        <div className="b-timeline-point__date--value">{dateTimeToView(autoEnteredAt)}</div>
                        <div className="b-timeline-point__date--value">{dateTimeToView(autoLeftAt)}</div>

                        <div className="b-timeline-point__date--name">Ручной</div>
                        <div className="b-timeline-point__date--value">{dateTimeToView(manualStartAt)}</div>
                        <div className="b-timeline-point__date--value">{dateTimeToView(manualEndAt)}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PointItemChange;
